export class MenuItem {
  path: string = "";
  title: string = "";
  icon: string = "";
  class: string = "";
  badge: string = "";
  badgeClass: string = "";
  isExternalLink: boolean = false;
  submenu: MenuItem[] = [];
  tenant: boolean = false;
  show: boolean = false;
  pointAttention: boolean = false;
  newFeature: boolean = false;

  constructor(title: string, _path = '', _tenant = false, _submenu = [], _icon = '', _class = '', _badgeClass = '', isExternalLink = false, show = true, pointAttention = false, newFeature = false) {
    this.title = title;
    this.path = _path;
    this.tenant = _tenant;
    this.submenu = _submenu;
    this.icon = _icon;
    this.class = _class;
    this.badgeClass = _badgeClass;
    this.isExternalLink = isExternalLink;
    this.show = show;
    this.pointAttention = pointAttention;
    this.newFeature = newFeature;
  }

  setPath(path: string): MenuItem {
    this.path = path;
    return this;
  }

  setTenant(tenant: boolean): MenuItem {
    this.tenant = tenant;
    return this;
  }

  setSubmenu(submenu: MenuItem[]): MenuItem {
    this.submenu = submenu;
    return this;
  }

  setIcon(icon: string): MenuItem {
    this.icon = icon;
    return this;
  }

  setClass(clazz: string): MenuItem {
    this.class = clazz;
    return this;
  }

  setBadgeClass(badgeClass: string): MenuItem {
    this.badgeClass = badgeClass;
    return this;
  }

  setExternalLink(isExternalLink: boolean): MenuItem {
    this.isExternalLink = isExternalLink;
    return this;
  }

  setShow(show: boolean): MenuItem {
    this.show = show;
    return this;
  }

  setPointAttention(pointAttention: boolean): MenuItem {
    this.pointAttention = pointAttention;
    return this;
  }

  setNewFeature(newFeature: boolean): MenuItem {
    this.newFeature = newFeature;
    return this;
  }

}
